/**
 * Validación de documentos de identidad por tipo DIAN (códigos en catalogos-dian.ts).
 * El NIT (código 31) verifica además el dígito de verificación por módulo 11.
 */

// Regex de formato por código DIAN. El NIT se valida aparte (formato + DV).
const REGEX_DOCUMENTO: Record<string, RegExp> = {
  '11': /^\d{8,11}$/, // registro civil
  '12': /^\d{8,11}$/, // tarjeta de identidad
  '13': /^\d{6,10}$/, // cédula de ciudadanía
  '21': /^[A-Za-z0-9]{4,12}$/, // tarjeta de extranjería
  '22': /^[A-Za-z0-9]{4,12}$/, // cédula de extranjería
  '41': /^[A-Za-z0-9]{5,15}$/, // pasaporte
  '42': /^[A-Za-z0-9]{5,20}$/, // documento de identificación extranjero
  '48': /^\d{7,15}$/, // permiso por protección temporal
};

const PESOS_NIT = [3, 7, 13, 17, 19, 23, 29, 37, 41, 43, 47, 53, 59, 67, 71];

/** Dígito de verificación del NIT (módulo 11, pesos DIAN). Recibe el NIT sin DV. */
export function digitoVerificacionNit(nitSinDv: string): number {
  const digitos = nitSinDv.replace(/\D/g, '').split('').reverse();
  let suma = 0;
  for (let i = 0; i < digitos.length; i++) suma += Number(digitos[i]) * (PESOS_NIT[i] ?? 0);
  const resto = suma % 11;
  return resto > 1 ? 11 - resto : resto;
}

/** Valida un NIT. Con DV (`900123456-8`) verifica el módulo 11; sin DV solo el formato. */
export function validarNit(numero: string): boolean {
  const limpio = (numero ?? '').replace(/\s/g, '');
  const m = limpio.match(/^(\d{9,10})-?(\d)?$/);
  if (!m) return false;
  const dv = m[2];
  if (dv === undefined) return true;
  return digitoVerificacionNit(m[1]!) === Number(dv);
}

/** Valida el número de documento según el tipo DIAN. */
export function validarDocumento(tipo: string, numero: string): boolean {
  const n = (numero ?? '').trim();
  if (tipo === '31') return validarNit(n);
  const re = REGEX_DOCUMENTO[tipo];
  return re ? re.test(n) : n.length > 0;
}
